import api from './api';
import apiNoHeaders from './apiNoHeaders';
import idbService from './idbService';
import { createTabelaPrecoModel } from '../utils/tabelaPrecoUtils';

// idb store name
const storeName = 'tabelasPreco';

// Recurso SQL Api Syclus
const environment = process.env.NODE_ENV;
const configLocal = localStorage.getItem('configPedidos');
const host = configLocal ? JSON.parse(configLocal).host : '';
const apiRequest = environment === 'production' ? api : apiNoHeaders;
const baseURL = environment === 'production' ? `erp?url=${host}` : host;
const endpoint = 'tabelapreco';
// const sqlTabelaPreco = 15;
// const sqlTabelaPrecoProduto = 16;

export const tabelaPrecoService = {
  getTabelasPreco,
  getTabelasPrecoAPI,
  getTabelaPreco,
  addTabelaPreco,
  addTabelasPreco,
  updateTabelaPreco,
  compareAndUpdateTabelasPreco
};

function getTabelasPreco() {
  // Fetch indexedDB Items
  // const itemsIndexedDB = await getIndexedDBTabelasPreco();
  // if (itemsIndexedDB.length) return itemsIndexedDB;
  // return getTabelasPrecoAPI();
  return getIndexedDBTabelasPreco();
}

async function getTabelasPrecoAPI() {
  const response = await apiRequest.post(`${baseURL}/${endpoint}`, {
    campos: [
      "id_tabela_preco",
      "tabela_preco",
      "data_inicial",
      "data_final",
      "itens"
    ],
    filtros: [
      {
        campo: "status",
        criterio: "igual",
        valor: "A"
      }
    ]
  }, {
    params: {
      Acao: 'lista'
    }
  });
  const tabelasPrecoApi = environment === 'production' ? response.data.result || [] : response.data || [];
  
  await compareAndUpdateTabelasPreco(tabelasPrecoApi);
  await removeInexistentes(tabelasPrecoApi);
  return tabelasPrecoApi;
}

// async function getTabelaPrecoAPI(idTabelaPreco) {
//   if (!idTabelaPreco) {
//     throw new Error('idTabelaPreco não informado');
//   }

//   try {
//     const response = await apiRequest.get(`${baseURL}/${endpoint}/${idTabelaPreco}`);
//     const tabelaPreco = environment === 'production' ? response.data.result : response.data;
//     await updateTabelaPreco(tabelaPreco)
//     return tabelaPreco;
//   } catch (error) {
//     console.log(error);
//     throw new Error('Ocorreu um erro ao buscar a tabela de preço');
//   }
// }

// TODO: Alterar o código do SQL futuramente
// function getTabelaPrecoProdutosAPI(idTabelaPreco) {
//   return apiRequest.get(`${baseURL}/sql/${sqlTabelaPrecoProduto}?:idTabelaPreco=${idTabelaPreco}`);
// }


function getIndexedDBTabelasPreco() {
  return idbService.getAll(storeName);
}

function getTabelaPreco(id) {
  return idbService.getById(storeName, id);
}

async function compareAndUpdateTabelasPreco(tabelasPreco) {
  if (tabelasPreco && tabelasPreco.length) {
    for (const tabelaPreco of tabelasPreco) {
      const savedTabelaPreco = await getTabelaPreco(tabelaPreco.id_tabela_preco);
  
      if (!savedTabelaPreco) {
        tabelaPreco.versao_imp = 1;
        await addTabelaPreco(tabelaPreco);
      } else {
        tabelaPreco.versao_imp = savedTabelaPreco.versao_imp ? savedTabelaPreco.versao_imp + 1 : 1;
        await updateTabelaPreco(tabelaPreco);
      }
    }
  } else {
    // Limpa os registros do store tabelaPrecos
    await idbService.clearStore(storeName);
  }
}

async function removeInexistentes(tabelasPrecoApi) {
  if (tabelasPrecoApi && tabelasPrecoApi.length) {
    const idsTabelasPrecoApi = tabelasPrecoApi.map(tabelaPrecoApi => tabelaPrecoApi.id_tabela_preco);
    const tabelasPrecoLocal = await idbService.getAll(storeName);
    const tabelasPrecoInexistentes = tabelasPrecoLocal.filter(tabelaPrecoLocal => !idsTabelasPrecoApi.includes(tabelaPrecoLocal.id_tabela_preco));
    if (tabelasPrecoInexistentes && tabelasPrecoInexistentes.length) {
      for (const tabelaPreco of tabelasPrecoInexistentes) {
        await idbService.deleteFromStore(storeName, tabelaPreco.id_tabela_preco);
      }
    }
  } else {
    return;
  }
}

async function addTabelaPreco(tabelaPreco) {
  // const parsedTabelaPreco = createTabelaPrecoModel(tabelaPreco);
  return idbService.addToStore(storeName, tabelaPreco);
}

async function addTabelasPreco(tabelasPreco = []) {
  const parsedTabelasPreco = tabelasPreco.map(tabelaPreco => createTabelaPrecoModel(tabelaPreco));
  return idbService.addMultipleToStore(storeName, parsedTabelasPreco);
}

async function updateTabelaPreco(tabelaPreco) {
  const parsedTabelaPreco = createTabelaPrecoModel(tabelaPreco);
  await idbService.updateItem(storeName, parsedTabelaPreco);
}